import { expect } from "@playwright/test";

export const testFavoriteToggleButton = async (page) => {
    const favButton = page
        .locator("ux-iws-async-toggle-button", { hasText: "Favorisieren" })
        .first();
    await expect(favButton).toBeVisible();
    await expect(favButton.getByText("Favorisieren")).toBeVisible();
    await expect(favButton.getByText("Favorit")).not.toBeVisible();
    await expect(favButton.locator("ux-icon[name=fav]")).toBeVisible();

    // After click
    await favButton.click();
    await expect(favButton.getByText("Favorisieren")).not.toBeVisible();
    await expect(favButton.getByText("Favorit")).toBeVisible();
    await expect(favButton.locator("ux-icon[name=fav-filled]")).toBeVisible();
};
